import {mapState,mapGetters} from 'vuex'
import {appActivationByTabDirective} from '@/directive/app-activation-by-tab-directive'

export var settingsMixin = {
    mixins: [appActivationByTabDirective],
    computed: {
        ...mapGetters('settings',['userId','isAdmin','aliasUser','isLoggedIn','lastLoggedInUserId','mainEventId','mainEventName','serverEasyEventSelection']),
        ...mapState('settings',['app_session','app_locale','app_user','app_loading','app_auth_error','app_token']),
        userOrAliasId(){
            return (this.aliasUser)?this.aliasUser.id:this.userId;
        },
        userLanguage(){
            return this.app_locale || this.$i18n.locale;
        },
    },
    watch: {
        '$route': {
            handler: function() {

            },
            deep: true,
            immediate: true
        }
    },
    data(){
        return {
        }
    },
    methods: {
        setAppLoading(isLoading){
            this.$store.commit('settings/SET_APP_LOADING', isLoading)
        },

        getPerson() {
            return new Promise((resolve, reject) => {
                this.$store.dispatch('settings/getPerson').then((response) => {
                    resolve(response)
                }).catch((ex) => {
                    this.logout().then(()=>{
                        reject(ex);
                    }).catch((ex) => {
                        reject(ex);
                    });
                    reject(ex);
                });
            });
        },

        // Refreshes the app settings (main event, easy_event_selection) via getplayer; never logs out or rejects
        loadAppSettings() {
            return this.$store.dispatch('settings/getPerson').catch(() => null);
        },

        login(credentials){

            //Logout - reinit Session - Register - Login
            return new Promise((resolve, reject) => {
                this.logout().then(()=>{
                    this.$store.dispatch('settings/login',credentials).then((responseLogin)=>{
                        if(responseLogin){
                            /* Remove user related game data if user has changed */
                            this.$nextTick(() => {
                                if(this.lastLoggedInUserId !=this.userId){
                                    this.$store.dispatch('events/destroyLocalStoredGameData');
                                }
                            });
                            resolve(responseLogin);
                        }else{
                            reject(null);
                        }
                    }).catch((ex) => {
                        reject(ex);
                    });
                }).catch((ex) => {
                    reject(ex);
                });
            });
        },
        loginWithQR(qrData) {
            //Logout - reinit Session - Register - Login
            return new Promise((resolve, reject) => {

                this.logout().then(()=>{
                    this.$store.dispatch('settings/loginWithQR',qrData).then((responseLogin)=>{

                        if(responseLogin){
                            /* Remove user related game data if user has changed */
                            this.$nextTick(() => {
                                if(this.lastLoggedInUserId !=this.userId){
                                    this.$store.dispatch('events/destroyLocalStoredGameData');
                                }
                            });
                            resolve(responseLogin);
                        }else{
                            reject(null);
                        }
                    }).catch((ex) => {
                        reject(ex);
                    });
                }).catch((ex) => {
                    reject(ex);
                });
            });
        },
        logout(){
            return new Promise((resolve) => {
                this.$store.dispatch('settings/logout').then(()=>{

                }).finally(()=>{
                    /* Remove stored data only*/
                    this.$store.dispatch('spots/destroy');
                    this.$store.dispatch('events/destroy');
                    resolve();
                });
            });
        },
        changePassword(d){
            return this.$store.dispatch('settings/changePassword',d);
        },
        requestPasswordChange(email){
            return this.$store.dispatch('settings/requestPasswordChange',email);
        },
        register(data){
            // console.log("register", data)
            //Logout - reinit Session - Register - Login
            return new Promise((resolve, reject) => {
                this.logout().then(()=>{
                    this.$store.dispatch('settings/register',data).then((responseRegister)=>{
                        if (responseRegister) {
                            resolve(responseRegister);
                        } else {
                            reject(null);
                        }
                    }).catch((ex) => {
                        reject(ex);
                    });
                }).catch((ex) => {
                    reject(ex);
                });
            });
        },
        registerAnonymous(data) {
            return new Promise((resolve, reject) => {
                this.logout().then(()=>{
                    this.register(data).then(()=> {
                        let credentials={
                            email:data.email,
                            password:data.password
                        };
                        this.login(credentials).then((responseLogin)=>{
                            resolve(responseLogin);
                        }).catch((ex)=>{
                            reject(ex);
                        });
                    }).catch((ex) => {
                        reject(ex);
                    });
                }).catch((ex) => {
                    reject(ex);
                });
            });
        },
        updateUserObject(user,data){
            this.$store.commit('settings/UPDATE_APP_USER', {user,data})
        },
        updateUser(data){
            return this.$store.dispatch('settings/updateUser',data);
        },
        getUserById(id){
            return this.$store.dispatch('settings/getUserById',id);
        },
        setAliasByUserId(id){
            return this.$store.dispatch('settings/setAliasByUserId',id);
        },
        onFocus(){
            //Inherit from appActivationByTabDirective
        },
        onBlur(){
            //Inherit from appActivationByTabDirective
        },
    },
    created: function () {
    }
}
